export default __webpack_public_path__ + "static/media/team80.5eebeaf7.JPG";